import { AavoRoutes } from "src/AavoRoutes.tsx";
import { ThemeProvider } from "@mui/material/styles";
import { AAVO_MUI_THEME } from "src/theme/theme.ts";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { AavoViewsProvider } from "./components/views/legacy/aavoViewsContext";
import { AavoToastProvider } from "./components/common/toast/AavoToastProvider";
import { PushNotificationsContextProvider } from "./notifications/pushNotificationsContext";
import { ConfirmDialogProvider } from "src/components/common/dialogs/confirmDialog/ConfirmDialogProvider.tsx";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { ErrorDialogProvider } from "src/components/common/dialogs/errorDialog/ErrorDialogProvider.tsx";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { getLanguageSetting } from "./localSettings/utils";
import { TenantCustomizationsContextProvider } from "src/tenantCustomizations/TenantCustomizationsContext";
import { BrowserRouter } from "react-router-dom";
import { MessageDialogProvider } from "./components/common/dialogs/messageDialog/MessageDialogProvider";
import Box from "@mui/material/Box";

const cache = createCache({
	key: "css",
	prepend: true,
});

function App() {
	return (
		<Box
			sx={{
				height: "100%",
				display: "flex",
			}}
		>
			<ThemeProvider theme={AAVO_MUI_THEME}>
				<CacheProvider value={cache}>
					<PushNotificationsContextProvider>
						<TenantCustomizationsContextProvider>
							<DndProvider backend={HTML5Backend}>
								<LocalizationProvider
									dateAdapter={AdapterDayjs}
									adapterLocale={getLanguageSetting()}
								>
									<BrowserRouter>
										<AavoViewsProvider>
											<AavoToastProvider>
												<ConfirmDialogProvider>
													<MessageDialogProvider>
														<ErrorDialogProvider>
															<AavoRoutes />
														</ErrorDialogProvider>
													</MessageDialogProvider>
												</ConfirmDialogProvider>
											</AavoToastProvider>
										</AavoViewsProvider>
									</BrowserRouter>
								</LocalizationProvider>
							</DndProvider>
						</TenantCustomizationsContextProvider>
					</PushNotificationsContextProvider>
				</CacheProvider>
			</ThemeProvider>
		</Box>
	);
}

export default App;
